export default {
  setGoodGroups(state, value) {
    state.goodGroups = value
  },
  appendLoadedGoodGroups(state, value) {
    state.goodGroups = value
  },
  setGoodGroup(state, value) {
    state.goodGroup = value
  },
  setGoodGroupFilters(state, value) {
    state.goodGroupFilters = value
  },
  addGoodGroup(state, item) {
    state.goodGroups.push(item)
  },
  changeGoodGroup(state, item) {
    for (let i = 0; i < state.goodGroups.length; i++) {
      if (state.goodGroups[i].id === item.id) {
        state.goodGroups.splice(i, 1, item)
        break
      }
    }
  },
  removeGoodGroup(state, id) {
    for (let i = 0; i < state.goodGroups.length; i++) {
      if (state.goodGroups[i].id === id) {
        state.goodGroups.splice(i, 1)
        break
      }
    }
  },
  setGoodGroupField(state, obj) {
    if (state.goodGroup) {
      state.goodGroup[obj.key] = obj.value ? obj.value : null
    }
  },
}
